export function GiftBox({ size = 110, opacity = 0.9 }) {
  return (
    <div aria-hidden style={{ width: size, height: size * 1.05, position: "relative", opacity, transformStyle: "preserve-3d" }}>
      <div className="gift-lid" />
      <div className="gift-body" />
      <div className="gift-ribbon-v" />
      <div className="gift-bow"><i className="l" /><i className="r" /><b /></div>
      <div className="gift-shadow" />
    </div>
  );
}
